export default {
      id: "blason-usage",
      viewBox: "0 0 380 470",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#blason-usage",
      toString: function () {
        return this.url;
      }
    }